exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._1guBpzpTsUDcnsmdMwAvuZ {\n  position: relative;\n  background-color: #191d1f0d;\n  width: 100%;\n  padding: 1rem;\n  line-height: 24px;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  font-size: 0.75rem;\n  margin-top: auto;\n}\n._1guBpzpTsUDcnsmdMwAvuZ ._3KlQ6RNEt7_5BM_V44cCzi {\n  margin: 0;\n  color: var(--gray-dark);\n}\n._1guBpzpTsUDcnsmdMwAvuZ ._1IblthowaVlVgBoagDAy_T {\n  justify-content: space-between;\n}\n._1guBpzpTsUDcnsmdMwAvuZ ._3NporQqNIe7fg0HG2LEN2A {\n  flex: 1;\n  margin-right: auto;\n}\n._1guBpzpTsUDcnsmdMwAvuZ ._3NporQqNIe7fg0HG2LEN2A a {\n  font-size: 0.75rem;\n}\n._1guBpzpTsUDcnsmdMwAvuZ ._2gqoPhZ7Xu0j_BDRHQD-Lr {\n  border-left: solid 1px var(--gray-dark);\n  height: 1rem;\n  display: inline;\n  margin: 8px;\n}\n._11ajuXnpBfwmT8wQRtIZ0o {\n  justify-content: space-between;\n}\n", ""]);

// exports
exports.locals = {
	"footer": "_1guBpzpTsUDcnsmdMwAvuZ",
	"copyrightText": "_3KlQ6RNEt7_5BM_V44cCzi",
	"filler": "_1IblthowaVlVgBoagDAy_T",
	"footerLinks": "_3NporQqNIe7fg0HG2LEN2A",
	"divider": "_2gqoPhZ7Xu0j_BDRHQD-Lr",
	"spacer": "_11ajuXnpBfwmT8wQRtIZ0o"
};